
import Vue from 'vue'
import DataTableCell from './DataTableCell.vue'

export default Vue.extend({
   name: 'ActionTable',
   props: {
      loading: { type: Boolean, default: false },
      data: Array as () => any[],
      headers: Array as () => NameValuePair[],
      actionLabel: { type: String, default: 'Action' },
   },
   methods: {
      action(row: object) {
         this.$emit('action', row)
      },
   },
   components: { DataTableCell },
})
